import { render } from "./DesktopNav.vue?vue&type=template&id=2888c979"
import script from "./DesktopNav.vue?vue&type=script&lang=js"
export * from "./DesktopNav.vue?vue&type=script&lang=js"

import "./DesktopNav.vue?vue&type=style&index=0&id=2888c979&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__